import $ from 'jquery';
import config from './../../config';
const URL_API = config.urlApi+'controlador/cita/getCitas.php';

export default function getCitas({values}){
    return $.ajax({
        url: URL_API,
        type: 'POST',
        data: values
    })
}